module.exports = __webpack_public_path__ + "static/headshot-1ec96cf5aa92cd3f6a8800f91ff19e0f.jpg";